import { render } from "./QuotationsDialog.vue?vue&type=template&id=0749f8cb&scoped=true"
import script from "./QuotationsDialog.vue?vue&type=script&lang=js"
export * from "./QuotationsDialog.vue?vue&type=script&lang=js"

import "./QuotationsDialog.vue?vue&type=style&index=0&id=0749f8cb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0749f8cb"]])

export default __exports__